export const mergeContextualColumns = (columns, influenceImpactGroupColumns) =>
  influenceImpactGroupColumns
    ? [...columns.filter(col => col[0] !== "influenceGroup"), ["influenceImpactGroup", influenceImpactGroupColumns]]
    : columns;

export const canEnableMetric = (aggregations, metricKey: string): boolean => {
  switch (metricKey) {
    case "depTime": {
      const patterns = [
        ["owMarket", "flightNumber", "depDate"],
        ["rtMarket", "flightNumber", "depDate"],
        ["origin", "destination", "flightNumber", "depDate"]
      ];

      return patterns.some(requiredAggregations => {
        return requiredAggregations.every(aggregation => aggregations.includes(aggregation));
      });
    }
    default:
      return true;
  }
};
